module.exports = __webpack_public_path__ + "static/media/email_verification.da99530f.png";